class Utility {
  static convertCheckBooleanToString = (visszaigazolasCheck) => {
    return visszaigazolasCheck == true ? ' (✓)' : ' (X)';
  }

  static insertByOrder = (array, elementNew) => {
    let insert = false;
    for (let o = 0; o < array.length; o++) {
      const element = array[o];
      if (element.props.children.localeCompare && element.props.children.localeCompare(elementNew.props.children) >= 0 ||
        element.props.children[0].localeCompare(elementNew.props.children) >= 0) {
        array.splice(o, 0, elementNew);
        insert = true;
        break;
      }
    }
    if (!insert)
      array.push(elementNew);
  }

  static returnFirstValueIfSingleElementArray = (array) => {
    return array.length == 1 ? array[0].props.value : null;
  }

  static preventNonNumeric = (e, onlyWholeNumber, regex) => {
    if (!regex) {
      if (onlyWholeNumber)
        regex = /^[a-zA-Z.,-]$/;
      else
        regex = /^[a-zA-Z,-]$/;
    }

    // Ctrl engedélyezve van, hogy Ctrl + A meg hasonló kombinációk ne legyenek megakadályozva
    if (e.ctrlKey)
      return;
    if (e.shiftKey || e.altKey || regex.test(e.key))
      e.preventDefault();
  }

  static validateNumericOnly = (onlyWholeNumber, required, regex, customNumberError, customReqError) => {
    if (!regex) {
      if (onlyWholeNumber)
        regex = '/^[0-9]+$/';
      else
        regex = '/^[0-9]+(.[0-9]+)*$/';
    }
    if (required == undefined)
      required = false;

    if (!customNumberError) {
      let string = onlyWholeNumber ? 'egész ' : '';
      customNumberError = 'Csak ' + string + 'szám írható be!';
    }
    if (!customReqError)
      customReqError = 'Kötelező mező!';
    return { pattern: { value: regex, errorMessage: customNumberError }, required: { value: required, errorMessage: customReqError } }
  };

}

export default Utility;